import { useState, useEffect } from "react";
// import yesIcon from "../../assets/Resources/Images/NewTickPng.png";
// import noIcon from "../../assets/Resources/Images/NewCrossPng.png";
import AllPageFooter from "./AllPageFooter";

const DoorRemedialActionPage = ({
  doorData,
  complianceList,
  imageProxyBaseUrl,
  //   preReq,
  PhysicalList,
  // originalDoor,
  // additionalPhotos,
  pageNum,
  logodata,
}) => {
  const [actionItems, setActionItems] = useState([]);
  // const [totalPhotoCount, setTotalPhotoCount] = useState(0);
  // console.log("inside door remedials");
  const isNullOrWhiteSpace = (str) => {
    return str == null || str.trim() === "";
  };

  // const doorId = doorData?.inspectedDoorId;

  // const showWhenCompliant = [
  //   "Any Visual defects on the door?",
  //   "Any damage to the door?",
  // ];

  const skipPhrases = [
    "Is there a hold open device?",
    "Is the fire door certification visible?",
    "Does the door contain glazing?",
    "Is a self-closing device fitted?",
  ];

  const hideWhenNonCompliant = [
    "Is the door free from visual defects?",
    "Is the door free from damage?",
    "Does the door fit correctly within the frame?",
    "Is the frame free from damage?",
  ];

  useEffect(() => {
    const loadDoorData = async () => {
      // Get DoorGlaze
      const doorGlaze = doorData?.doorGlaze;

      const hasGlazing = !(doorGlaze.toLowerCase() === "no");

      const doorChecks = complianceList;

      let combined = [];
      // DEBUG: Track what's being filtered out
      let skippedBySkipPhrases = 0;
      let skippedByGlazing = 0;
      let skippedByHideWhenNonCompliant = 0;
      let skippedByNoSeverity = 0;
      let addedCount = 0;

      doorChecks.map((c) => {
        const checklist = (c.checkListName ?? "").trim();

        // skipPhrases check
        if (
          skipPhrases.some((p) => checklist.toLowerCase() === p.toLowerCase())
        ) {
          skippedBySkipPhrases++;
          return;
        }

        // no glazing check
        if (
          !hasGlazing &&
          checklist.toLowerCase().includes("is fire-rated (pyro) glazing installed?")
        ) {
          skippedByGlazing++;
          return;
        }

        // hideWhenNonCompliant: only hide if non-compliant AND no severity
        if (
          hideWhenNonCompliant.some(
            (p) => p.toLowerCase() === checklist.toLowerCase(),
          ) &&
          !c.isCompliant &&
          isNullOrWhiteSpace(c.severity)
        ) {
          skippedByHideWhenNonCompliant++;
          return;
        }

        // skip if no severity AND no action text
        if (
          isNullOrWhiteSpace(c.severity) &&
          isNullOrWhiteSpace(c.remediation) &&
          isNullOrWhiteSpace(c.comment)
        ) {
          skippedByNoSeverity++;
          return;
        }

        addedCount++;

        // default severity to "Low" when empty
        const severityDisplay = !isNullOrWhiteSpace(c.severity)
          ? c.severity
          : "Low";

        // resolve first non-empty photo
        const photosList = c.photos ?? [];
        const raw = photosList.find((p) => !isNullOrWhiteSpace(p)) ?? null;
        const proxied = raw ? resolveProxy(raw, imageProxyBaseUrl) : null;

        // convert numeric category to text
        const categoryText = !isNullOrWhiteSpace(c.category)
          ? getCategoryText(c.category)
          : "";

        combined.push({
          title: checklist,
          severity: severityDisplay,
          comment: c.comment,
          remediation: c.remediation,
          dueDate: c.dueDate,
          category: categoryText,
          photoUrl: proxied,
          value: null,
        });
      });
      console.log(
        "counts",
        skippedByGlazing,
        skippedByHideWhenNonCompliant,
        skippedByNoSeverity,
        skippedBySkipPhrases,
        addedCount,
      );

      //for physical measurements
      const phyData = PhysicalList[0];

      const parts = [
        { title: "Head", item: phyData?.head },
        { title: "Hinge", item: phyData?.hinge },
        { title: "Closing", item: phyData?.closing },
        { title: "Threshold", item: phyData?.threshold },
        { title: "NoOfHinges", item: phyData?.noOfHinges },
        { title: "LeftHead", item: phyData?.leftHead },
        { title: "RightHead", item: phyData?.rightHead },
        { title: "LeftHinge", item: phyData?.leftHinge },
        { title: "RightHinge", item: phyData?.rightHinge },
        { title: "LeftThreshold", item: phyData?.leftThreshold },
        { title: "RightThreshold", item: phyData?.rightThreshold },
      ];
      let physicalAdded = 0;
      let physicalSkippedActionItem = 0;
      let physicalSkippedNoSeverity = 0;
      parts.forEach((p) => {
        const it = p.item;
        if (it === null || !(it.actionItem.toLowerCase() === "yes")) {
          physicalSkippedActionItem++;
          return;
        }
        if (isNullOrWhiteSpace(it.severity)) {
          physicalSkippedNoSeverity++;
          return;
        }
        physicalAdded++;
        const photolist = it.photos ?? [];
        const raw = photolist.find((p) => !isNullOrWhiteSpace(p)) ?? null;
        const proxied = raw ? resolveProxy(raw, imageProxyBaseUrl) : null;

        const categoryText = !isNullOrWhiteSpace(it.category)
          ? getCategoryText(it.category)
          : "";
        combined.push({
          title: p.title,
          severity: it.severity,
          comment: it.comment,
          remediation: it.remediation,
          dueDate: it.dueDate,
          category: categoryText,
          photoUrl: proxied,
          value: it.value,
        });
      });
      console.log(
        "skipped physical",
        physicalAdded,
        physicalSkippedActionItem,
        physicalSkippedNoSeverity,
      );

      //for custom compliance data
      const jsonString = phyData?.customComplianceActionJson ?? "";
      if (
        !isNullOrWhiteSpace(jsonString) &&
        jsonString !== "[]" &&
        jsonString !== "null" &&
        jsonString.startsWith("[")
      ) {
        const customAction = JSON.parse(jsonString);
        let customAdded = 0;
        let customSkippedActionItem = 0;
        let customSkippedNoSeverity = 0;
        if (Array.isArray(customAction) && customAction.length > 0) {
          customAction.forEach((customActionElement) => {
            try {
              const actionItem = customActionElement?.ActionItem ?? "";
              if (
                isNullOrWhiteSpace(actionItem) ||
                !(actionItem.toLowerCase() === "yes")
              ) {
                customSkippedActionItem++;
                return;
              }
              // Convert numeric severity to text; default to "Low" when empty (align with Action Plan)
              let severity;
              if (!isNullOrWhiteSpace(customActionElement?.Severity ?? "")) {
                severity = getSeverityText(customActionElement?.Severity ?? "");
              } else {
                customSkippedNoSeverity++;
                return;
              }
              customAdded++;
              const photolist = customActionElement.Photos ?? [];
              const raw = photolist.find((p) => !isNullOrWhiteSpace(p)) ?? null;
              const proxied = raw ? resolveProxy(raw, imageProxyBaseUrl) : null;

              const categoryText = !isNullOrWhiteSpace(
                customActionElement.Category,
              )
                ? getCategoryText(customActionElement.Category)
                : "";
              combined.push({
                title: customActionElement?.CustomLabel ?? "Custom Action",
                severity: severity ?? "",
                comment: customActionElement?.Comment ?? "",
                remediation: customActionElement?.Remediation ?? "",
                dueDate: customActionElement?.DueDate ?? "",
                category: categoryText,
                photoUrl: proxied,
                value: customActionElement.Value ?? null,
              });
            } catch (err) {
              //skip
              return;
            }
          });
        }
        console.log(
          "skipped custom",
          customAdded,
          customSkippedActionItem,
          customSkippedNoSeverity,
        );
      }
      const totalActionItems = combined.length;
      console.log("total", totalActionItems);
      setActionItems(combined);
    };

    loadDoorData();
  }, [doorData, imageProxyBaseUrl, complianceList]);

  const resolveProxy = (str) => {
    if (isNullOrWhiteSpace(str)) return null;
    str = str.trim();
    if (str.startsWith("data:")) return str;
    if (str.length > 500 && /^[A-Za-z0-9+/=]+$/.test(str)) {
      return "data:image/jpeg;base64," + str;
    }
    return `${imageProxyBaseUrl}${str}`;
  };

  // Helper functions to convert numeric IDs to text values for custom action items
  const getSeverityText = (severity) => {
    if (isNullOrWhiteSpace(severity)) return "Low";

    const s = severity.trim();
    const sLower = s.toLowerCase();

    // Handle numeric severity values (1=Critical, 2=High, 3=Medium, 4=Low)
    if (s === "1") return "Critical";
    if (s === "2") return "High";
    if (s === "3") return "Medium";
    if (s === "4") return "Low";

    // Handle text severity values
    if (sLower === "critical" || sLower === "urgent") return "Critical";
    if (sLower === "high") return "High";
    if (sLower === "medium" || sLower === "moderate") return "Medium";
    if (sLower === "low") return "Low";

    // Fallback
    return "Low";
  };

  const getCategoryText = (category) => {
    if (isNullOrWhiteSpace(category)) return "";

    const c = category.trim();
    const cLower = c.toLowerCase();

    // Handle numeric category values
    if (c === "1") return "Firedoor Repair";
    if (c === "2") return "Signage repair";
    if (c === "3") return "Fire door Replacement";
    if (c === "4") return "Testing, Records, Log Book";
    if (c === "5") return "Door Replacement required";
    if (c === "6") return "Door Repair";

    // Handle text category values (case-insensitive)
    if (
      cLower.includes("firedoor repair") ||
      cLower.includes("fire door repair")
    )
      return "Firedoor Repair";
    if (cLower.includes("signage repair")) return "Signage repair";
    if (cLower.includes("fire door replacement"))
      return "Fire door Replacement";
    if (
      cLower.includes("testing") ||
      cLower.includes("records") ||
      cLower.includes("log book")
    )
      return "Testing, Records, Log Book";
    if (cLower.includes("door replacement required"))
      return "Door Replacement required";
    if (cLower.includes("door repair") && !cLower.includes("replacement"))
      return "Door Repair";

    // Return as-is if already text
    return category;
  };

  const sevClass = (str) => {
    const s = (str ?? "")?.trim()?.toLowerCase();
    // Map urgent to critical (same color: #a52a2a)
    if (s.includes("critical") || s.includes("urgent")) return "critical";
    if (s.includes("high")) return "high";
    if (s.includes("medium")) return "medium";
    if (s.includes("low")) return "low";
    return "low";
  };

  const formatPhysicalValue = (c) => {
    if (c == null || isNullOrWhiteSpace(c.value)) return null;

    const title = (c.title ?? "").trim();
    const val = c.value.trim();

    if (title.toLowerCase() === "nofhinges") {
      const n = parseFloat(val);
      if (!isNaN(n)) {
        return Number.isInteger(n) ? String(Math.trunc(n)) : val;
      }
      return val;
    }

    const isGap =
      title.toLowerCase() === "head" ||
      title.toLowerCase() === "hinge" ||
      title.toLowerCase() === "closing" ||
      title.toLowerCase() === "threshold";

    if (isGap) {
      const num = parseFloat(val);
      if (!isNaN(num)) return `${num.toFixed(1)} mm`;
    }

    return val;
  };

  const formatTitle = (t) => {
    if (isNullOrWhiteSpace(t)) return t;
    return t.toLowerCase() === "nofhinges" ? "No Of Hinges" : t;
  };

  const doorLocationText = !isNullOrWhiteSpace(doorData?.doorLocation)
    ? `${doorData?.doorLocation}`
    : `${doorData?.floorNo}`;
  const photosperPage = 3;
  const totalPhotos = actionItems?.length || 0;
  const totalPages = Math.ceil(totalPhotos / photosperPage);
  // console.log("door", doorData?.doorRefNumber, totalPages, totalPhotos);

  if (actionItems?.length > 0) {
    return (
      <>
        {actionItems &&
          Array.from({ length: totalPages }).map((_, pageIndex) => {
            const startindex = pageIndex * photosperPage;
            const endIndex = Math.min(startindex + photosperPage, totalPhotos);
            const pagePhotos = actionItems?.slice(startindex, endIndex);
            const isLastPage = pageIndex === totalPages - 1 ? true : false;

            return (
              <div
                key={`remedials - ${pageIndex}`}
                className={
                  isLastPage
                    ? "page ra ra-page sheet door-remedials-wrapper"
                    : "page ra ra-page sheet door-remedials-wrapper last-page"
                }
              >
                <table className="ra-hdr">
                  <tbody>
                    <tr>
                      <td className="ra-hdrL">
                        <div className="ra-hTitle">Flat Doors</div>
                        <p className="ra-hDesc">{doorLocationText}</p>
                      </td>
                      <td className="ra-hdrR">
                        <div className="ra-qrBox">
                          {!isNullOrWhiteSpace(doorData?.surveyQRCodeBase64) ? (
                            <img
                              className="ra-qrPh"
                              src={doorData?.surveyQRCodeBase64}
                              alt="QR Code"
                            />
                          ) : (
                            <div className="ra-qrPh"></div>
                          )}
                          <div className="ra-qrRef">
                            {doorData?.doorRefNumber}
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="ra-rule"></div>
                <div className="ra-title">Remedial Actions</div>
                {/* <div className="photosSection"> */}
                {/* <div className="photoGrid"> */}
                {pagePhotos &&
                  pagePhotos.map((item, i) => {
                    const severityClass = sevClass(item?.severity);
                    const disp = formatPhysicalValue(item);
                    const headline = !isNullOrWhiteSpace(disp)
                      ? `${formatTitle(item.title)}: ${disp}`
                      : `${formatTitle(item.title)}`;
                    const dueDateObj = item?.dueDate
                      ? new Date(item?.dueDate)
                      : null;

                    return (
                      <div
                        key={`remedials ${pageIndex - i}`}
                        className="ra-card"
                      >
                        <table className="ra-cardTbl">
                          <tbody>
                            <tr>
                              {/* photo */}
                              <td className="ra-photo" rowSpan={2}>
                                {!isNullOrWhiteSpace(item?.photoUrl) ? (
                                  <div className="ra-photoBox">
                                    <img src={item?.photoUrl} alt="evidence" />
                                  </div>
                                ) : (
                                  <div className="ra=photoBox is-empty"></div>
                                )}
                              </td>

                              {/* main content */}
                              <td className="ra-mid">
                                {/* <!-- Headline --> */}
                                <div className="ra-headline">{headline}</div>

                                {/* <!-- Due / Category --> */}
                                <table className="ra-duCat">
                                  <tr>
                                    <td className="ra-du">
                                      <div className="ra-k">Due Date</div>
                                      <div className="ra-v">
                                        {dueDateObj
                                          ? dueDateObj.toLocaleDateString(
                                              "en-GB",
                                              {
                                                
day: "2-digit",
  month: "2-digit",
  year: "numeric",

                                              },
                                            )
                                          : "-"}
                                      </div>
                                    </td>
                                    <td className="ra-ca">
                                      <div className="ra-k">Category</div>
                                      <div className="ra-v">
                                        {!isNullOrWhiteSpace(item?.category) ? item.category : "-"}
                                      </div>
                                    </td>
                                  </tr>
                                </table>

                                {/* <!-- Comment --> */}
                                <div className="ra-line">
                                  <div className="ra-k">Comment</div>
                                  <div className="ra-v">
                                    {!isNullOrWhiteSpace(item?.comment) ? item.comment : "-"}
                                  </div>
                                </div>
                              </td>
                              {/* <!-- Severity --> */}
                              <td className="ra-sev">
                                <span className={`ra-pill ${severityClass}`}>
                                  Priority:
                                  {item?.severity ?? "-"}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td className="ra-remedial" colSpan="2">
                                <div className="ra-k">
                                  Remedial / Action Required
                                </div>
                                <div className="ra-v">
                                  {!isNullOrWhiteSpace(item?.remediation) ? item.remediation : "-"}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    );
                  })}
                <AllPageFooter
                  pageNumber={pageNum?.[pageIndex]}
                  propLogo={logodata?.propShieldLogoBase64}
                />
              </div>
            );
          })}
      </>
    );
  } else {
    return <></>;
  }
};

export default DoorRemedialActionPage;
